import * as types from "../services/configurationActionType";
import initialState from "../../../../store/initialState";

const configurationReducer = (state = initialState.configuration, action) => {
  switch (action.type) {
    // Site Coverage Details Cases
    case types.FETCH_SITE_COVERAGE_DETAILS_REQUEST:
      return { ...state, isSiteCoverageLoading: true };

    case types.FETCH_SITE_COVERAGE_DETAILS_SUCCESS:
      return {
        ...state,
        isSiteCoverageLoading: false,
        SiteCoverageMatrix:
          action.payload.listSiteCoverageDetails || action.payload,
      };

    case types.FETCH_SITE_COVERAGE_DETAILS_FAILURE:
      return { ...state, isSiteCoverageLoading: false, SiteCoverageMatrix: [] };

    // Site Coverage Detail By ID Cases
    // Uses its own loading flag (not isSiteCoverageLoading) so the edit modal's
    // loader stays tied to this specific fetch.
    case types.FETCH_SITE_COVERAGE_DETAIL_BY_ID_REQUEST:
      return { ...state, isSiteCoverageDetailByIdLoading: true };

    case types.FETCH_SITE_COVERAGE_DETAIL_BY_ID_SUCCESS:
      return {
        ...state,
        isSiteCoverageDetailByIdLoading: false,
        SiteCoverageDetailByID: action.payload,
      };

    case types.FETCH_SITE_COVERAGE_DETAIL_BY_ID_FAILURE:
      return {
        ...state,
        isSiteCoverageDetailByIdLoading: false,
        SiteCoverageDetailByID: null,
      };

    // Delete Site Coverage Detail Cases
    case types.DELETE_SITE_COVERAGE_DETAIL_REQUEST:
      return { ...state, isSiteCoverageLoading: true };

    case types.DELETE_SITE_COVERAGE_DETAIL_SUCCESS:
      return { ...state, isSiteCoverageLoading: false };

    case types.DELETE_SITE_COVERAGE_DETAIL_FAILURE:
      return { ...state, isSiteCoverageLoading: false };

    // Save Site Coverage Detail Cases
    case types.SAVE_SITE_COVERAGE_DETAIL_REQUEST:
      return {
        ...state,
        isSiteCoverageLoading: true,
        lastSavedSiteCoverage: null,
        lastSavedSiteCoverageError: null,
      };

    case types.SAVE_SITE_COVERAGE_DETAIL_SUCCESS:
      return {
        ...state,
        isSiteCoverageLoading: false,
        lastSavedSiteCoverage: action.payload,
      };

    case types.SAVE_SITE_COVERAGE_DETAIL_FAILURE:
      return {
        ...state,
        isSiteCoverageLoading: false,
        lastSavedSiteCoverageError: action.payload || true,
      };

    //Coverage Gap Cases
    case types.FETCH_COVERAGE_GAP_REQUEST:
      return { ...state, isCoverageGapLoading: true };
    case types.FETCH_COVERAGE_GAP_SUCCESS:
      return {
        ...state,
        isCoverageGapLoading: false,
        coverageGaps: action.payload.listRVUConfiguration,
      };
    case types.FETCH_COVERAGE_GAP_FAILURE:
      return { ...state, isCoverageGapLoading: false, coverageGaps: [] };

    case types.FETCH_COVERAGE_GAP_BY_ID_REQUEST:
      return { ...state, isCoverageGapLoading: true };
    case types.FETCH_COVERAGE_GAP_BY_ID_SUCCESS:
      return {
        ...state,
        isCoverageGapLoading: false,
        selectedCoverageGap: action.payload,
      };
    case types.FETCH_COVERAGE_GAP_BY_ID_FAILURE:
      return {
        ...state,
        isCoverageGapLoading: false,
        selectedCoverageGap: null,
      };

    case types.SAVE_COVERAGE_GAP_REQUEST:
      return { ...state, isCoverageGapLoading: true };
    case types.SAVE_COVERAGE_GAP_SUCCESS:
      return { ...state, isCoverageGapLoading: false };
    case types.SAVE_COVERAGE_GAP_FAILURE:
      return { ...state, isCoverageGapLoading: false };

    case types.DELETE_COVERAGE_GAP_REQUEST:
      return { ...state, isCoverageGapLoading: true };
    case types.DELETE_COVERAGE_GAP_SUCCESS:
      return { ...state, isCoverageGapLoading: false };
    case types.DELETE_COVERAGE_GAP_FAILURE:
      return { ...state, isCoverageGapLoading: false };

    // Priority SLA Mappings Cases - Fixed to match component expectations
    case types.FETCH_PRIORITY_SLA_MAPPINGS_REQUEST:
      return { ...state, isPrioritySLAMappingLoading: true };
    case types.FETCH_PRIORITY_SLA_MAPPINGS_SUCCESS:
      return {
        ...state,
        isPrioritySLAMappingLoading: false,
        prioritySLAMappings: action.payload,
      };
    case types.FETCH_PRIORITY_SLA_MAPPINGS_FAILURE:
      return {
        ...state,
        isPrioritySLAMappingLoading: false,
        prioritySLAMappings: [],
      };

    case types.FETCH_PRIORITY_SLA_MAPPING_BY_ID_REQUEST:
      return { ...state, isPrioritySLAMappingLoading: true };
    case types.FETCH_PRIORITY_SLA_MAPPING_BY_ID_SUCCESS:
      return {
        ...state,
        isPrioritySLAMappingLoading: false,
        selectedPrioritySLAMapping: action.payload,
      };
    case types.FETCH_PRIORITY_SLA_MAPPING_BY_ID_FAILURE:
      return {
        ...state,
        isPrioritySLAMappingLoading: false,
        selectedPrioritySLAMapping: null,
      };

    case types.SAVE_PRIORITY_SLA_MAPPING_REQUEST:
      return { ...state, isPrioritySLAMappingLoading: true };
    case types.SAVE_PRIORITY_SLA_MAPPING_SUCCESS:
      return {
        ...state,
        isPrioritySLAMappingLoading: false,
        selectedPrioritySLAMapping: null,
      };
    case types.SAVE_PRIORITY_SLA_MAPPING_FAILURE:
      return { ...state, isPrioritySLAMappingLoading: false };

    case types.DELETE_PRIORITY_SLA_MAPPING_REQUEST:
      return { ...state, isPrioritySLAMappingLoading: true };
    case types.DELETE_PRIORITY_SLA_MAPPING_SUCCESS:
      return { ...state, isPrioritySLAMappingLoading: false };
    case types.DELETE_PRIORITY_SLA_MAPPING_FAILURE:
      return { ...state, isPrioritySLAMappingLoading: false };

    case types.DROPDOWN_PRIORITY_REQUEST:
      return { ...state, isPriorityLoading: true };
    case types.DROPDOWN_PRIORITY_SUCCESS:
      return {
        ...state,
        isPriorityLoading: false,
        priorityDropdown: action.payload || [],
      };
    case types.DROPDOWN_PRIORITY_FAILURE:
      return { ...state, isPriorityLoading: false, priorityDropdown: [] };

    case types.ACTIVATE_DEACTIVATE_PRIORITY_SLA_MAPPING_REQUEST:
      return { ...state, isPrioritySLAMappingLoading: true };
    case types.ACTIVATE_DEACTIVATE_PRIORITY_SLA_MAPPING_SUCCESS:
      return { ...state, isPrioritySLAMappingLoading: false };
    case types.ACTIVATE_DEACTIVATE_PRIORITY_SLA_MAPPING_FAILURE:
      return { ...state, isPrioritySLAMappingLoading: false };

    case types.FETCH_PRIORITY_SLA_BUCKETS_REQUEST:
      return { ...state, isPrioritySLABucketsLoading: true };
    case types.FETCH_PRIORITY_SLA_BUCKETS_SUCCESS:
      return {
        ...state,
        isPrioritySLABucketsLoading: false,
        prioritySLABuckets:
          action.payload?.lstPriorityBuckets || action.payload || [],
      };
    case types.FETCH_PRIORITY_SLA_BUCKETS_FAILURE:
      return {
        ...state,
        isPrioritySLABucketsLoading: false,
        prioritySLABuckets: [],
      };

    // License Mapping Cases
    case types.FETCH_STATE_LICENSE_MAPPING_REQUEST:
      return {
        ...state,
        isStateLicenseMappingLoading: true,
        stateLicenseMappingError: null,
      };

    case types.FETCH_STATE_LICENSE_MAPPING_SUCCESS:
      return {
        ...state,
        isStateLicenseMappingLoading: false,
        stateLicenseMappings:
          action.payload?.licenseMappings ||
          action.payload?.lstLicenseMappings ||
          action.payload ||
          [],
      };

    case types.FETCH_STATE_LICENSE_MAPPING_FAILURE:
      return {
        ...state,
        isStateLicenseMappingLoading: false,
        stateLicenseMappings: [],
        stateLicenseMappingError:
          action.payload || "Failed to fetch license mapping.",
      };

    case types.FETCH_STATE_LICENSE_MAPPING_DROPDOWN_REQUEST:
      return {
        ...state,
        isStateLicenseMappingLoading: true,
      };

    case types.FETCH_STATE_LICENSE_MAPPING_DROPDOWN_SUCCESS:
      return {
        ...state,
        isStateLicenseMappingLoading: false,
        stateLicenseMappingDropdown:
          action.payload?.stateLicenseStatusList ||
          action.payload?.lstStateLicenseStatus ||
          action.payload ||
          [],
      };

    case types.FETCH_STATE_LICENSE_MAPPING_DROPDOWN_FAILURE:
      return {
        ...state,
        isStateLicenseMappingLoading: false,
        stateLicenseMappingDropdown: [],
        stateLicenseMappingError:
          action.payload || "Failed to fetch license mapping dropdown.",
      };

    case types.SAVE_STATE_LICENSE_MAPPING_BULK_REQUEST:
      return {
        ...state,
        isStateLicenseMappingSaving: true,
        stateLicenseMappingError: null,
      };

    case types.SAVE_STATE_LICENSE_MAPPING_BULK_SUCCESS:
      return {
        ...state,
        isStateLicenseMappingSaving: false,
      };

    case types.SAVE_STATE_LICENSE_MAPPING_BULK_FAILURE:
      return {
        ...state,
        isStateLicenseMappingSaving: false,
        stateLicenseMappingError:
          action.payload || "Failed to save license mapping.",
      };

    // Privileges Mapping Cases
    case types.FETCH_PRIVILEGES_MAPPING_REQUEST:
      return {
        ...state,
        isPrivilegesMappingLoading: true,
        privilegesMappingError: null,
      };

    case types.FETCH_PRIVILEGES_MAPPING_SUCCESS:
      return {
        ...state,
        isPrivilegesMappingLoading: false,
        privilegesMappings:
          action.payload?.privilegesMappings ||
          action.payload?.listPrivilegesMapping ||
          action.payload ||
          [],
      };
    case types.FETCH_DEFINE_MISMATCH_REQUEST:
      return {
        ...state,
        isDefineMismatchLoading: true,
        defineMismatchError: null,
      };

    case types.FETCH_DEFINE_MISMATCH_SUCCESS:
      return {
        ...state,
        isDefineMismatchLoading: false,
        defineMismatchList:
          action.payload?.defineMismatchList ||
          action.payload?.lstDefineMismatch ||
          action.payload ||
          [],
      };

    case types.FETCH_PRIVILEGES_MAPPING_FAILURE:
      return {
        ...state,
        isPrivilegesMappingLoading: false,
        privilegesMappings: [],
        privilegesMappingError:
          action.payload || "Failed to fetch privileges mapping.",
      };

    case types.FETCH_PRIVILEGES_MAPPING_DROPDOWN_REQUEST:
      return {
        ...state,
        isPrivilegesMappingLoading: true,
      };

    case types.FETCH_PRIVILEGES_MAPPING_DROPDOWN_SUCCESS:
      return {
        ...state,
        isPrivilegesMappingLoading: false,
        privilegesMappingDropdown:
          action.payload?.privilegesStatusList ||
          action.payload?.listPrivilegesStatus ||
          action.payload ||
          [],
      };

    case types.FETCH_PRIVILEGES_MAPPING_DROPDOWN_FAILURE:
      return {
        ...state,
        isPrivilegesMappingLoading: false,
        privilegesMappingDropdown: [],
        privilegesMappingError:
          action.payload || "Failed to fetch privileges mapping dropdown.",
      };

    case types.SAVE_PRIVILEGES_MAPPING_BULK_REQUEST:
      return {
        ...state,
        isPrivilegesMappingSaving: true,
        privilegesMappingError: null,
      };

    case types.SAVE_PRIVILEGES_MAPPING_BULK_SUCCESS:
      return {
        ...state,
        isPrivilegesMappingSaving: false,
      };

    case types.SAVE_PRIVILEGES_MAPPING_BULK_FAILURE:
      return {
        ...state,
        isPrivilegesMappingSaving: false,
        privilegesMappingError:
          action.payload || "Failed to save privileges mapping.",
      };

    // Reading Status Mapping Cases
    case types.FETCH_READING_STATUS_MAPPING_REQUEST:
      return {
        ...state,
        isReadingStatusMappingLoading: true,
        readingStatusMappingError: null,
      };

    case types.FETCH_READING_STATUS_MAPPING_SUCCESS:
      return {
        ...state,
        isReadingStatusMappingLoading: false,
        readingStatusMappings:
          action.payload?.readingStatusMappings ||
          action.payload?.listReadingStatusMapping ||
          action.payload ||
          [],
      };

    case types.FETCH_READING_STATUS_MAPPING_FAILURE:
      return {
        ...state,
        isReadingStatusMappingLoading: false,
        readingStatusMappings: [],
        readingStatusMappingError:
          action.payload || "Failed to fetch reading status mapping.",
      };

    case types.FETCH_READING_STATUS_MAPPING_DROPDOWN_REQUEST:
      return {
        ...state,
        isReadingStatusMappingLoading: true,
      };

    case types.FETCH_READING_STATUS_MAPPING_DROPDOWN_SUCCESS:
      return {
        ...state,
        isReadingStatusMappingLoading: false,
        readingStatusMappingDropdown:
          action.payload?.readingStatusList ||
          action.payload?.listReadingStatus ||
          action.payload ||
          [],
      };

    case types.FETCH_READING_STATUS_MAPPING_DROPDOWN_FAILURE:
      return {
        ...state,
        isReadingStatusMappingLoading: false,
        readingStatusMappingDropdown: [],
        readingStatusMappingError:
          action.payload || "Failed to fetch reading status mapping dropdown.",
      };

    case types.SAVE_READING_STATUS_MAPPING_BULK_REQUEST:
      return {
        ...state,
        isReadingStatusMappingSaving: true,
        readingStatusMappingError: null,
      };

    case types.SAVE_READING_STATUS_MAPPING_BULK_SUCCESS:
      return {
        ...state,
        isReadingStatusMappingSaving: false,
      };

    case types.SAVE_READING_STATUS_MAPPING_BULK_FAILURE:
      return {
        ...state,
        isReadingStatusMappingSaving: false,
        readingStatusMappingError:
          action.payload || "Failed to save reading status mapping.",
      };

    case types.FETCH_DEFINE_MISMATCH_FAILURE:
      return {
        ...state,
        isDefineMismatchLoading: false,
        defineMismatchList: [],
        defineMismatchError: action.payload || "Failed to fetch Define Mismatch.",
      };

    case types.FETCH_DEFINE_MISMATCH_DROPDOWN_REQUEST:
      return {
        ...state,
        isDefineMismatchLoading: true,
      };

    case types.FETCH_DEFINE_MISMATCH_DROPDOWN_SUCCESS:
      return {
        ...state,
        isDefineMismatchLoading: false,
        defineMismatchDropdowns: action.payload || {},
      };

    case types.FETCH_DEFINE_MISMATCH_DROPDOWN_FAILURE:
      return {
        ...state,
        isDefineMismatchLoading: false,
        defineMismatchDropdowns: {
          privilegeStatusList: [],
          readingStatusList: [],
          licenseStatusList: [],
        },
        defineMismatchError:
          action.payload || "Failed to fetch Define Mismatch dropdown.",
      };

    case types.SAVE_DEFINE_MISMATCH_REQUEST:
      return {
        ...state,
        isDefineMismatchSaving: true,
        defineMismatchError: null,
      };

    case types.SAVE_DEFINE_MISMATCH_SUCCESS:
      return {
        ...state,
        isDefineMismatchSaving: false,
      };

    case types.SAVE_DEFINE_MISMATCH_FAILURE:
      return {
        ...state,
        isDefineMismatchSaving: false,
        defineMismatchError: action.payload || "Failed to save Define Mismatch.",
      };

    case types.ACTIVATE_DEACTIVATE_DEFINE_MISMATCH_REQUEST:
      return {
        ...state,
        isDefineMismatchSaving: true,
        defineMismatchError: null,
      };

    case types.ACTIVATE_DEACTIVATE_DEFINE_MISMATCH_SUCCESS:
      return {
        ...state,
        isDefineMismatchSaving: false,
      };

    case types.ACTIVATE_DEACTIVATE_DEFINE_MISMATCH_FAILURE:
      return {
        ...state,
        isDefineMismatchSaving: false,
        defineMismatchError:
          action.payload || "Failed to update Define Mismatch status.",
      };

    case types.DELETE_DEFINE_MISMATCH_REQUEST:
      return {
        ...state,
        isDefineMismatchSaving: true,
        defineMismatchError: null,
      };

    case types.DELETE_DEFINE_MISMATCH_SUCCESS:
      return {
        ...state,
        isDefineMismatchSaving: false,
      };

    case types.DELETE_DEFINE_MISMATCH_FAILURE:
      return {
        ...state,
        isDefineMismatchSaving: false,
        defineMismatchError:
          action.payload || "Failed to delete Define Mismatch details.",
      };

    // Shift Hour Configuration cases
    case types.FETCH_SHIFT_HOUR_REQUEST:
      return { ...state, isShiftHourLoading: true };

    case types.FETCH_SHIFT_HOUR_SUCCESS:
      return {
        ...state,
        isShiftHourLoading: false,
        shiftHourList: action.payload?.shiftHourList || action.payload || [],
      };

    case types.FETCH_SHIFT_HOUR_FAILURE:
      return { ...state, isShiftHourLoading: false, shiftHourList: [] };

    //--------------------- DLS Configuration Reducer - Start---------------------//
    // DLS Configuration Cases
    case types.FETCH_DLS_CONFIGURATION_REQUEST:
      return { ...state, isDLSConfigurationLoading: true };
    case types.FETCH_DLS_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isDLSConfigurationLoading: false,
        dlsConfigurations:
          action.payload.configurationsList || action.payload || [],
      };
    case types.FETCH_DLS_CONFIGURATION_FAILURE:
      return {
        ...state,
        isDLSConfigurationLoading: false,
        dlsConfigurations: [],
      };

    // Sites Without DLS Cases
    case types.FETCH_SITES_WITHOUT_DLS_REQUEST:
      return { ...state, isSitesWithoutDLSLoading: true };
    case types.FETCH_SITES_WITHOUT_DLS_SUCCESS:
      return {
        ...state,
        isSitesWithoutDLSLoading: false,
        sitesWithoutDLS:
          action.payload.dlsSiteDetailsList || action.payload || [],
      };
    case types.FETCH_SITES_WITHOUT_DLS_FAILURE:
      return { ...state, isSitesWithoutDLSLoading: false, sitesWithoutDLS: [] };

    // Save DLS Configuration Cases
    case types.SAVE_DLS_CONFIGURATION_REQUEST:
      return { ...state, isDLSSaveLoading: true };
    case types.SAVE_DLS_CONFIGURATION_SUCCESS:
      return { ...state, isDLSSaveLoading: false };
    case types.SAVE_DLS_CONFIGURATION_FAILURE:
      return { ...state, isDLSSaveLoading: false };
    //--------------------- DLS Configuration Reducer - End---------------------//

    // Block Planning Cases
    case types.FETCH_BLOCK_PLANNING_REQUEST:
      return { ...state, isBlockPlanningLoading: true };
    case types.FETCH_BLOCK_PLANNING_SUCCESS:
      return {
        ...state,
        isBlockPlanningLoading: false,
        blockPlannings: action.payload?.blockPlanningColorList || [],
      };
    case types.FETCH_BLOCK_PLANNING_FAILURE:
      return { ...state, isBlockPlanningLoading: false, blockPlannings: [] };

    // Delete Block Planning Cases
    case types.DELETE_BLOCK_PLANNING_REQUEST:
      return { ...state, isDeleteLoading: true };

    case types.DELETE_BLOCK_PLANNING_SUCCESS:
      return { ...state, isDeleteLoading: false };

    case types.DELETE_BLOCK_PLANNING_FAILURE:
      return { ...state, isDeleteLoading: false };

    // Save Block Planning Cases
    case types.SAVE_BLOCK_PLANNING_REQUEST:
      return { ...state, isBlockPlanningLoading: true };

    case types.SAVE_BLOCK_PLANNING_SUCCESS:
      return { ...state, isBlockPlanningLoading: false };

    case types.SAVE_BLOCK_PLANNING_FAILURE:
      return { ...state, isBlockPlanningLoading: false };

    // Fetch Block Planning By ID Cases
    case types.FETCH_BLOCK_PLANNING_BY_ID_REQUEST:
      return { ...state, isBlockPlanningLoading: true };

    case types.FETCH_BLOCK_PLANNING_BY_ID_SUCCESS:
      return {
        ...state,
        isBlockPlanningLoading: false,
        selectedBlockPlanning: action.payload,
      };

    case types.FETCH_BLOCK_PLANNING_BY_ID_FAILURE:
      return {
        ...state,
        isBlockPlanningLoading: false,
        selectedBlockPlanning: null,
      };

    // Task Configuration Cases
    case types.FETCH_TASK_CONFIGURATION_DETAILS_REQUEST:
      return { ...state, isTaskConfigurationLoading: true };

    case types.FETCH_TASK_CONFIGURATION_DETAILS_SUCCESS:
      return {
        ...state,
        isTaskConfigurationLoading: false,
        TaskConfiguration: action.payload.taskList || action.payload || [],
        WorkListDetailsList: action.payload.workListDetailsList || [],
        TaskCategoryDetailsList: action.payload.taskCategoryDetailsList || [],
        TaskTypeDetailsList: action.payload.taskTypeDetailsList || [],
      };

    case types.FETCH_TASK_CONFIGURATION_DETAILS_FAILURE:
      return {
        ...state,
        isTaskConfigurationLoading: false,
        TaskConfiguration: [],
        WorkListDetailsList: [],
        TaskCategoryDetailsList: [],
        TaskTypeDetailsList: [],
      };

    // Save Task configuration Cases
    case types.SAVE_TASK_CONFIGURATION_REQUEST:
      return {
        ...state,
        isTaskConfigurationLoading: true,
        taskSaveInlineError: "",
      };

    case types.SAVE_TASK_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isTaskConfigurationLoading: false,
        taskSaveInlineError: "",
      };

    case types.SAVE_TASK_CONFIGURATION_FAILURE:
      return {
        ...state,
        isTaskConfigurationLoading: false,
        taskSaveInlineError:
          typeof action.payload === "string"
            ? action.payload
            : action.payload?.inlineError || action.payload?.error || "",
      };

    // Task Configuration By ID Cases
    case types.FETCH_TASK_CONFIGURATION_BY_ID_REQUEST:
      return { ...state, isTaskConfigurationLoading: true };

    case types.FETCH_TASK_CONFIGURATION_BY_ID_SUCCESS:
      return {
        ...state,
        isTaskConfigurationLoading: false,
        selectedTaskConfiguration: action.payload,
      };

    case types.FETCH_TASK_CONFIGURATION_BY_ID_FAILURE:
      return {
        ...state,
        isTaskConfigurationLoading: false,
        selectedTaskConfiguration: null,
      };

    // Delete Task Configuration Cases
    case types.DELETE_TASK_CONFIGURATION_REQUEST:
      return { ...state, isTaskConfigurationLoading: true };

    case types.DELETE_TASK_CONFIGURATION_SUCCESS:
      return { ...state, isTaskConfigurationLoading: false };

    case types.DELETE_TASK_CONFIGURATION_FAILURE:
      return { ...state, isTaskConfigurationLoading: false };

    //Activate Deactivate Task Configuration Cases
    case types.ACTIVATE_DEACTIVATE_TASK_CONFIGURATION_REQUEST:
      return { ...state, isTaskConfigurationLoading: true };
    case types.ACTIVATE_DEACTIVATE_TASK_CONFIGURATION_SUCCESS:
      return { ...state, isTaskConfigurationLoading: false };
    case types.ACTIVATE_DEACTIVATE_TASK_CONFIGURATION_FAILURE:
      return { ...state, isTaskConfigurationLoading: false };

    case types.TASK_BULK_UPDATE_REQUEST:
      return { ...state, isTaskConfigurationLoading: true };
    case types.TASK_BULK_UPDATE_SUCCESS:
      return { ...state, isTaskConfigurationLoading: false };
    case types.TASK_BULK_UPDATE_FAILURE:
      return { ...state, isTaskConfigurationLoading: false };

    // Task Tags Cases
    case types.FETCH_TASK_TAGS_REQUEST:
      return {
        ...state,
        isTaskTagsLoading: true,
        taskTagsError: null,
      };
    case types.FETCH_TASK_TAGS_SUCCESS:
      return {
        ...state,
        isTaskTagsLoading: false,
        taskTags: Array.isArray(action.payload) ? action.payload : [],
        taskTagsError: null,
      };
    case types.FETCH_TASK_TAGS_FAILURE:
      return {
        ...state,
        isTaskTagsLoading: false,
        taskTags: [],
        taskTagsError: action.payload || "Failed to load task tags.",
      };

    case types.SAVE_TASK_TAGS_REQUEST:
      return {
        ...state,
        isTaskTagsSaving: true,
        taskTagsError: null,
      };
    case types.SAVE_TASK_TAGS_SUCCESS:
      return {
        ...state,
        isTaskTagsSaving: false,
        taskTagsError: null,
      };
    case types.SAVE_TASK_TAGS_FAILURE:
      return {
        ...state,
        isTaskTagsSaving: false,
        taskTagsError: action.payload || "Failed to save task tags.",
      };

    // Provider Task Pool Cases
    case types.FETCH_PROVIDER_TASK_POOL_REQUEST:
      return {
        ...state,
        isProviderTaskPoolLoading: true,
        providerTaskPoolError: null,
      };
    case types.FETCH_PROVIDER_TASK_POOL_SUCCESS: {
      const values = action.payload?.values || action.payload || {};
      return {
        ...state,
        isProviderTaskPoolLoading: false,
        providerTaskPoolHeader:
          values?.header || values?.taskHeader || values?.TaskHeader || null,
        providerTaskPoolProviders:
          values?.providers ||
          values?.providerRows ||
          values?.ProviderRows ||
          [],
        providerTaskPoolOccurrenceOptions:
          values?.occurrenceOptions || values?.OccurrenceOptions || [],
        providerTaskPoolConflicts: values?.conflicts || values?.Conflicts || [],
        providerTaskPoolLastSaved: values,
        providerTaskPoolError: null,
      };
    }
    case types.FETCH_PROVIDER_TASK_POOL_FAILURE:
      return {
        ...state,
        isProviderTaskPoolLoading: false,
        providerTaskPoolError:
          action.payload || "Failed to load provider pool.",
      };

    case types.SAVE_PROVIDER_TASK_POOL_REQUEST:
      return {
        ...state,
        isProviderTaskPoolSaving: true,
        providerTaskPoolError: null,
      };
    case types.SAVE_PROVIDER_TASK_POOL_SUCCESS: {
      const values = action.payload?.values || action.payload || {};
      return {
        ...state,
        isProviderTaskPoolSaving: false,
        providerTaskPoolHeader:
          values?.header ||
          values?.taskHeader ||
          values?.TaskHeader ||
          state.providerTaskPoolHeader,
        providerTaskPoolProviders:
          values?.providers ||
          values?.providerRows ||
          values?.ProviderRows ||
          state.providerTaskPoolProviders,
        providerTaskPoolOccurrenceOptions:
          values?.occurrenceOptions ||
          values?.OccurrenceOptions ||
          state.providerTaskPoolOccurrenceOptions,
        providerTaskPoolConflicts:
          values?.conflicts ||
          values?.Conflicts ||
          state.providerTaskPoolConflicts,
        providerTaskPoolLastSaved: values,
        providerTaskPoolError: null,
      };
    }
    case types.SAVE_PROVIDER_TASK_POOL_FAILURE:
      return {
        ...state,
        isProviderTaskPoolSaving: false,
        providerTaskPoolError:
          action.payload || "Failed to save provider pool.",
      };

    case types.FETCH_PROVIDER_TASK_POOL_PROVIDER_OPTIONS_REQUEST:
      return {
        ...state,
        isProviderTaskPoolProviderOptionsLoading: true,
      };
    case types.FETCH_PROVIDER_TASK_POOL_PROVIDER_OPTIONS_SUCCESS:
      return {
        ...state,
        isProviderTaskPoolProviderOptionsLoading: false,
        providerTaskPoolProviderOptions:
          action.payload?.values || action.payload || [],
      };
    case types.FETCH_PROVIDER_TASK_POOL_PROVIDER_OPTIONS_FAILURE:
      return {
        ...state,
        isProviderTaskPoolProviderOptionsLoading: false,
        providerTaskPoolProviderOptions: [],
      };

    case types.ADD_PROVIDER_TASK_POOL_PROVIDERS_REQUEST:
    case types.REMOVE_PROVIDER_TASK_POOL_PROVIDER_REQUEST:
      return {
        ...state,
        isProviderTaskPoolSaving: true,
        providerTaskPoolError: null,
      };
    case types.ADD_PROVIDER_TASK_POOL_PROVIDERS_SUCCESS:
    case types.REMOVE_PROVIDER_TASK_POOL_PROVIDER_SUCCESS:
      return {
        ...state,
        isProviderTaskPoolSaving: false,
        providerTaskPoolError: null,
      };
    case types.ADD_PROVIDER_TASK_POOL_PROVIDERS_FAILURE:
    case types.REMOVE_PROVIDER_TASK_POOL_PROVIDER_FAILURE:
      return {
        ...state,
        isProviderTaskPoolSaving: false,
        providerTaskPoolError:
          action.payload || "Failed to update provider pool.",
      };

    case types.EXPORT_PROVIDER_TASK_POOL_REQUEST:
      return {
        ...state,
        isProviderTaskPoolExporting: true,
      };
    case types.EXPORT_PROVIDER_TASK_POOL_SUCCESS:
      return {
        ...state,
        isProviderTaskPoolExporting: false,
      };
    case types.EXPORT_PROVIDER_TASK_POOL_FAILURE:
      return {
        ...state,
        isProviderTaskPoolExporting: false,
        providerTaskPoolError:
          action.payload || "Failed to export provider pool.",
      };

    //--------------------- Day of Week Configuration Reducer - Start---------------------//
    // Day of Week Configuration Cases
    case types.FETCH_DAY_OF_WEEK_CONFIGURATION_REQUEST:
      return { ...state, isDayOfWeekConfigurationLoading: true };

    case types.FETCH_DAY_OF_WEEK_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isDayOfWeekConfigurationLoading: false,
        dayOfWeekConfigurations: action.payload,
        weekDayList: action.payload.weekDayList || [],
        weekEndList: action.payload.weekEndList || [],
      };

    case types.FETCH_DAY_OF_WEEK_CONFIGURATION_FAILURE:
      return {
        ...state,
        isDayOfWeekConfigurationLoading: false,
        dayOfWeekConfigurations: [],
        weekDayList: [],
        weekEndList: [],
      };
    //--------------------- Day of Week Configuration Reducer - End---------------------//

    //--------------------- Simulation Cases -------------------//
    // Fetch Simulation Cases
    case types.FETCH_SIMULATION_REQUEST:
      return { ...state, isSimulationLoading: true };
    case types.FETCH_SIMULATION_SUCCESS:
      return {
        ...state,
        isSimulationLoading: false,
        simulations: action.payload?.simulatorColorList,
      };
    case types.FETCH_SIMULATION_FAILURE:
      return { ...state, isSimulationLoading: false, simulations: [] };
    // Save Simulation Cases
    case types.SAVE_SIMULATION_REQUEST:
      return { ...state, isSimulationLoading: true };
    case types.SAVE_SIMULATION_SUCCESS:
      return { ...state, isSimulationLoading: false };
    case types.SAVE_SIMULATION_FAILURE:
      return { ...state, isSimulationLoading: false };
    // Delete Simulation Cases
    case types.DELETE_SIMULATION_REQUEST:
      return { ...state, isSimulationLoading: true };
    case types.DELETE_SIMULATION_SUCCESS:
      return { ...state, isSimulationLoading: false };
    case types.DELETE_SIMULATION_FAILURE:
      return { ...state, isSimulationLoading: false };
    // Fetch Simulation By ID Cases
    case types.FETCH_SIMULATION_BY_ID_REQUEST:
      return { ...state, isSimulationLoading: true };
    case types.FETCH_SIMULATION_BY_ID_SUCCESS:
      return {
        ...state,
        isSimulationLoading: false,
        selectedSimulation: action.payload,
      };
    case types.FETCH_SIMULATION_BY_ID_FAILURE:
      return { ...state, isSimulationLoading: false, selectedSimulation: null };
    //--------------------- End of Simulation Cases -------------------//

    //common cases
    case types.UPDATE_CONFIGURATION_REDUCER:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default configurationReducer;
